import React, { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";

const ShipTable = ({deliveryNoteData, deliveryNoteItems }) => {
  const tableRef = useRef();
  const [rowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState([]);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = deliveryNoteItems.slice(indexOfFirstRow, indexOfLastRow);

  const isAllSelected =
    deliveryNoteItems.length > 0 && selectedRows.length === deliveryNoteItems.length;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = deliveryNoteItems.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  useEffect(() => {
    const cols = tableRef.current?.querySelectorAll("th");
    cols?.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div
      className="row"
      style={{ border: "1px solid #00000059", borderRadius: "5px", marginBottom: "20px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Shipment Details</p>
      </div>
      <div className="">
        <table className="table table-bordered mb-1" ref={tableRef}>
          <thead className="tableHead1">
            <tr>
              {[ "S.No", "Shipment", "Shipment Date", "Boxes Shipped", "Owner", "Created At"].map((title, i) => {
                const defaultWidths = {
                  "Action": "20px",
                  "S.No": "20px",
                  "Shipment": "150px",
                  "Shipment Date": "120px",
                  "Boxes Shipped": "100px",
                  "Owner": "180px",
                  "Created At": "180px",
                };

                return (
                  <th
                    key={i}
                    style={{
                      fontSize: "7px",
                      position: "relative",
                      textAlign:
                        title === "Action" || title === "S.No" ? "center" : "left",
                      width: defaultWidths[title] || "150px",
                      minWidth: defaultWidths[title] || "150px",
                    }}
                  >
                    {title === "Action" ? (
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{
                          backgroundColor: isAllSelected ? "#270b79" : "",
                          borderColor: isAllSelected ? "#270b79" : "",
                          fontSize: "15px",
                        }}
                        checked={isAllSelected}
                        onChange={handleSelectAll}
                      />
                    ) : (
                      title
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>

          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map((item, index) => {
                const globalIndex = indexOfFirstRow + index;
                return (
                  <tr key={globalIndex}>
       
                    <td style={{ textAlign: "center", fontSize: "0.8rem", padding: "0.5rem" }}>
                      {globalIndex + 1}
                    </td>
                    <td className="p-0" style={{ fontSize: "0.8rem", paddingLeft: "8px" }}>
                      {item.shipment}
                    </td>
                    <td className="p-0" style={{ fontSize: "0.8rem", paddingLeft: "8px" }}>
                      {item.shipment_date}
                    </td>
                    <td className="p-0" style={{ fontSize: "0.8rem", paddingLeft: "8px" }}>
                      {item.boxes_shipped}
                    </td>
                    <td className="p-0" style={{ fontSize: "0.8rem", paddingLeft: "8px" }}>
                      {item.owner}
                    </td>
                    <td className="p-0" style={{ fontSize: "0.8rem", paddingLeft: "8px" }}>
                      {item.creation}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No shipment data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="d-flex align-items-center" style={{ gap: '8px', marginBottom: '5px', marginTop : '5px' }}>
  <input
    type="checkbox"
    checked={deliveryNoteData?.custom_is_shipment_booked === 1 || deliveryNoteData?.custom_is_shipment_booked === '1'}
    readOnly
    style={{
      accentColor: '#733699',
      width: '16px',
      height: '16px',
      cursor: 'default',
    }}
  />
  <label className="m-0" style={{ fontSize: '13px', color: '#000' }}>
    Is Full Shipment Booked?
  </label>
</div>


        <div className="d-flex pb-2 justify-content-between align-items-center">
          <div className="d-flex" style={{ gap: "4px" }}>
            <Button
              className="createbtn d-flex"
              style={{ gap: "2px", height: "28px" }}
              iconName="MdOutlineFileDownload"
              iconSize={12}
            >
              Download
            </Button>
          </div>

          <div
            className={`${
              deliveryNoteItems.length < 11 ? "d-none" : "d-flex"
            } align-items-center centerpagination`}
            style={{ gap: "5px" }}
          >
            <Pagination
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              pageSize={rowsPerPage}
              totalrecords={deliveryNoteItems.length}
            />
          </div>

          <div className={`${deliveryNoteItems.length < 11 ? "d-none" : "d-flex"}`}>
            <span
              className="px-2"
              style={{ fontSize: "12px", color: "#270B79" }}
            >
              Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, deliveryNoteItems.length)} of {deliveryNoteItems.length} entries
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipTable;
